module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-candy@2x-7e1afe51856b20c559a7891f9e5d2104.png";